import React, { Component } from 'react';
import { SearchGroup } from './search';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import { Grid, Cell } from 'react-flexr';

class TagFilter extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { headline, items, filters, checkboxOnChange, feed, offerType } = this.props;

    const tags = items.reduce((acc, item) => {
      if (!item.get('usps')) {
        return acc;
      }

      const usps = Array.from(item.get('usps'));
      for (let index = 0; index < usps.length; index++) {
        const tag = usps[index];
        if (!acc.includes(tag) && typeof tag === 'string') {
          acc.push(tag);
        }
      }
      return acc;
    }, []);

    const filteredTags = (filters.tags || []).map((v) => v.toLowerCase());
    const tagUrlBase = '/' + offerType;

    return (
      <SearchGroup headline={'Tags'}>
        {headline ? (
          <Grid
            style={{
              fontSize: '1.4em',
              lineHeight: '1em',
              whiteSpace: 'nowrap',
              marginBottom: 11
            }}
          >
            <Cell key={headline}>{headline}</Cell>
          </Grid>
        ) : null}
        {tags.sort().filter(Boolean).map(tag => (
            <Checkbox
              key={tag}
              name={tag.toLowerCase()}
              onChange={checkboxOnChange}
              checked={filteredTags.includes(tag.toLowerCase())}
              value={tag}
            >
              {tag}
              {feed ? null : <a href={`${tagUrlBase}/${tag}`.toLowerCase()} style={{ display: 'none' }}>{tag}</a>}
            </Checkbox>
          ))}
      </SearchGroup>
    );
  }
}

export default TagFilter;
